module.exports = __webpack_public_path__ + "static/media/billing_info.b7b6aa61.svg";